type Props = {
  className?: string;
};
export default function GasStationWave({ className }: Props) {
  return (
    <svg
      width="42"
      height="73"
      viewBox="0 0 42 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19 4.50044C37.5 -3.99956 42 4.50044 42 4.50044V73.0005H-3.8147e-06V2.00042C-3.8147e-06 2.00042 0.5 13.0004 19 4.50044Z"
        fill="url(#paint0_linear_1641_130435)"
        fillOpacity="0.6"
      />
      <path
        d="M22.5 12.0082C33.5 4.50816 42 22.0082 42 22.0082V73.0082H0V21.0082C0 21.0082 11.5 19.5082 22.5 12.0082Z"
        fill="url(#paint1_linear_1641_130435)"
      />
      <path
        d="M21.5 28.5C32.5 21 42 22 42 22V73H0V21C0 21 10.5 36 21.5 28.5Z"
        fill="url(#paint2_linear_1641_130435)"
        fillOpacity="0.8"
      />
      <path
        d="M15 40.0068C26 32.5068 42 44.0067 42 44.0067V73.0068H0V33.0068C0 33.0068 4 47.5068 15 40.0068Z"
        fill="url(#paint3_linear_1641_130435)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1641_130435"
          x1="21"
          y1="1.00043"
          x2="21"
          y2="73.0004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--color)" />
          <stop offset="1" stopColor="var(--color)" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1641_130435"
          x1="21"
          y1="10.0082"
          x2="21"
          y2="73.0082"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--color)" />
          <stop offset="0.495" stopColor="var(--color)" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1641_130435"
          x1="21"
          y1="21"
          x2="21"
          y2="73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--color)" />
          <stop offset="1" stopColor="var(--color)" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1641_130435"
          x1="21"
          y1="33.0067"
          x2="21"
          y2="73.0067"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--color)" />
          <stop offset="1" stopColor="var(--color)" stopOpacity="1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
